import React from 'react';
import { CircularProgress, Grid, Typography } from "@mui/material"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CommentType, WorkItemType } from "../../../api/projects-api"
import { Comment } from "./Comment"
import {CommentInput} from "./CommentInput"
import { getLocation } from '../../../app/cookies';
import { CommentsPartType, fetchCommentsTC_ } from './comments-reducer';
import { AppRootState } from '../../../app/store';

type CommentsPropsType = {
  workItemID: number
  projectName: string
  projectId: number
  item: WorkItemType
  relationLength: number
  taskCommentsPart: CommentsPartType
}

export const Comments = React.memo((props: CommentsPropsType) => {
  const dispatch = useDispatch()
  let myCommentText = ''
  let comments = [] as Array<CommentType>
  if(props.taskCommentsPart) {
    myCommentText = props.taskCommentsPart.myCommentText
    comments = props.taskCommentsPart.commentsData?.comments
  }
  
  const taskId = getLocation().itemID
  const projectName = getLocation().projectName
  const projectId = getLocation().projectId
  const isCommentsFetched = useSelector<AppRootState, boolean>(state => state.commentApp.isCommentsFetched)
  
  useEffect(() => {
  dispatch(fetchCommentsTC_({ projectName: projectName, projectId, taskId }))
  }, [])

  
  console.log('COMMENTS: ', comments)
  console.log('isCommentsFetched: ', isCommentsFetched)

  return (
    <>
     <Grid container className='retroSteps' >
          <Typography className='titleHover' >
            <b>Discussion</b>
          </Typography>
          <Grid container>
            <Grid item xl={12} xs={12} >
              <hr />
            </Grid>
            
            <Grid item xl={12} xs={12}>
              <CommentInput projectName={props.projectName} myCommetText={myCommentText} projectId={props.projectId} item={props.item}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid container >
          {comments !== undefined || isCommentsFetched !== true ?  <Grid item xl={12} xs={12}>
            {comments?.map(c =>  <Comment key={c.text} comment = {c}/> )}
          </Grid> : <CircularProgress color="info" thickness={2} size={20} style={{ position: 'fixed',marginTop: '20px', left:'50%',  width: 80, height: 80 }} /> }

        </Grid>
    </>)
})
